module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-Medium.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-Medium.eot
// module id = 448
// module chunks = 0